import { useEffect, useState } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { api } from "./api";
import Layout from "./components/Layout";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import SchedulesPage from "./pages/SchedulesPage";
import RunsPage from "./pages/RunsPage";
import BackupsPage from "./pages/BackupsPage";
import SettingsPage from "./pages/SettingsPage";

interface AuthState {
  user: { id: number; username: string } | null;
  needsBootstrap: boolean;
  loading: boolean;
}

export default function App() {
  const [auth, setAuth] = useState<AuthState>({ user: null, needsBootstrap: false, loading: true });
  const location = useLocation();

  async function refresh() {
    try {
      const [me, boot] = await Promise.all([api.getMe(), api.bootstrapStatus()]);
      setAuth({ user: me.user, needsBootstrap: boot.needsBootstrap, loading: false });
    } catch {
      setAuth({ user: null, needsBootstrap: false, loading: false });
    }
  }

  useEffect(() => { void refresh(); }, []);

  if (auth.loading) return <div className="login-shell muted">Loading…</div>;

  if (!auth.user) {
    return (
      <Routes>
        <Route
          path="*"
          element={
            <LoginPage
              needsBootstrap={auth.needsBootstrap}
              onAuthed={() => void refresh()}
            />
          }
        />
      </Routes>
    );
  }

  return (
    <Layout user={auth.user} onLogout={() => { void api.logout().then(() => refresh()); }}>
      <Routes>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/schedules" element={<SchedulesPage />} />
        <Route path="/runs" element={<RunsPage />} />
        <Route path="/backups" element={<BackupsPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="*" element={<Navigate to="/dashboard" replace state={{ from: location }} />} />
      </Routes>
    </Layout>
  );
}
